import PropTypes from "prop-types";
import * as React from "react";
import QuickActionTile from "../templates/quickActionTile";
import SingleLinkTile from "../templates/singleLinkTile";
import { DATA_MARKETPLACE } from "../../../constants/externalUrls";
import { quickActionTilesMap } from "../tilesMap";

const DataMarketplaceTile = ({ id }) => {
    return (
        <QuickActionTile id={id}>
            <SingleLinkTile
                title={"Data Marketplace"}
                link={DATA_MARKETPLACE}
                linkText={quickActionTilesMap[id].description}
            />
        </QuickActionTile>
    );
};

DataMarketplaceTile.propTypes = {
    id: PropTypes.string.isRequired,
};

export default DataMarketplaceTile;
